<template>
  <el-dialog
      :visible.sync="dialogVisible"
      :title="'单据详情，' + tableData.length"
      width="85%"
      top="2vh">
    <!--    <el-button :loading="exportLoading" style="margin-bottom: 5px" type="primary" @click="exportExcel">导出</el-button>-->
    <el-table v-loading="contentLoading" height="76vh" :data="tableData">
      <el-table-column prop="billNo" align="left" label="单号" width="150" fixed="left">
        <template slot-scope="scope">
          <span v-if="scope.row.isOvertime===1" style="color: red;">{{ scope.row.billNo }}</span>
          <span v-else>{{ scope.row.billNo }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="requireDate" align="center" label="需求日期" width="90">
        <template slot-scope="scope">
          <span v-if="scope.row.isOvertime===1" style="color: red;">{{ scope.row.requireDate }}</span>
          <span v-else>{{ scope.row.requireDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="statusName" width="90" align="center" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.isOvertime===1" style="color: red;">{{ scope.row.statusName }}</span>
          <span v-else>{{ scope.row.statusName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="stockTime" width="160" label="配料时间">
        <template slot-scope="scope">
          <span v-if="scope.row.isOvertime===1" style="color: red;">{{ scope.row.stockTime }}</span>
          <span v-else>{{ scope.row.stockTime }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="stockUserName" width="90" label="配料人">
        <template slot-scope="scope">
          <span v-if="scope.row.isOvertime===1" style="color: red;">{{ scope.row.stockUserName }}</span>
          <span v-else>{{ scope.row.stockUserName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="materialNo" align="center" label="物料编号" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.isOvertime===1" style="color: red;">{{ scope.row.materialNo }}</span>
          <span v-else>{{ scope.row.materialNo }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="materialName" align="center" label="物料名称" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.isOvertime===1" style="color: red;">{{ scope.row.materialName }}</span>
          <span v-else>{{ scope.row.materialName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="specification" align="center" label="规格型号">
        <template slot-scope="scope">
          <span v-if="scope.row.isOvertime===1" style="color: red;">{{ scope.row.specification }}</span>
          <span v-else>{{ scope.row.specification }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" align="center" width="80" label="数量">
        <template slot-scope="scope">
          <span v-if="scope.row.isOvertime===1" style="color: red;">{{ scope.row.quantity }}</span>
          <span v-else>{{ scope.row.quantity }}</span>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import constant from "@/util/constant";

export default {
  name: "StockRptDetailList",
  data() {
    return {
      constant,
      dialogVisible: false,
      contentLoading: false,
      exportLoading: false,
      tableData: [],
      tableDataBill: [],
      salesOrderType: null,
      countType: null,
      queryType: null,
      productType: null,
      searchType: null,
      startTime: null,
      endTime: null,
      cycleEndDate: null,
      deliveryTimeType: null,
    };
  },
  methods: {
    cellClassName({row}) {
      console.log(row);
      return row.isOvertime === 1 ? "highlight-red" : "";
    },
    open(params) {
      this.tableData = [];
      this.tableDataBill = [];
      this.dialogVisible = true;
      this.getList(params);
    },
    getList(params) {
      this.contentLoading = true;
      this.$http.get("basic", "stockRpt/stockReport_V2", params)
          .then((res) => {
            this.contentLoading = false;
            this.tableData = res.data;
          }).catch(() => {
        this.contentLoading = false;
        // this.$message.error("获取失败");
      });
    },
    exportExcel() {
      this.exportLoading = true;
      let params = {
        "startTime": this.startTime,
        "endTime": this.endTime,
        "queryType": this.queryType,
        "countType": this.countType,
        "productType": this.productType,
        "searchType": this.searchType,
      };
      this.$http
          .exportFile("basic", "productReports/exportWorkOrderDetailOnDate", params, 60 * 10000)
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          }).catch(() => {
        this.exportLoading = false;
        this.$message.error("导出失败");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.highlight-red {
  color: #ff0000;
}
</style>
